import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=0a95e6a1&"
import script from "./Milestones.vue?vue&type=script&lang=js&"
export * from "./Milestones.vue?vue&type=script&lang=js&"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=0a95e6a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports